import gql from 'graphql-tag'


export const getAudioFiles = gql`
  query AudioFiles($filter: GetAudioFilesFilter) {
  audioFiles(filter: $filter) {
    isSuccessful
    errorCode
    errorName
    message
    status
    audioFiles {
      data {
        audioFileId
        companyId
        label
        audioFileUrl
      }
      pagination {
        total
        page
        show
        startCursor
        endCursor
        actualTotal
      }
    }
  }
}
`

export const createAudioFile = gql`
  mutation UploadAudioFile($input: UploadAudioFileInput) {
  uploadAudioFile(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    uploadAudioFile {
      audioFileId
      companyId
      label
      audioFileUrl
    }
  }
}
`


export const deleteAudioFile = gql`
  mutation DeleteAudioFiles($input: DeleteAudioFilesInput!) {
  deleteAudioFiles(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    deleteAudioFiles {
      count
    }
  }
}
`

export const updateAudioFile = gql`
  mutation UpdateAudioFile($input: UpdateAudioFileInput!) {
  updateAudioFile(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    updateAudioFile {
      audioFileId
      companyId
      label
      audioFileUrl
    }
  }
}`


export const audioAssignments = gql`
  query AudioAssignments($filter: AudioAssignmentsFilter!) {
  audioAssignments(filter: $filter) {
    isSuccessful
    errorCode
    errorName
    message
    status
    audioAssignments {
      data {
        audioAssignmentId
        companyId
        audioFileId
        label
        assignmentType
        assignmentValue
        audioFile {
          audioFileId
          companyId
          label
          audioFileUrl
        }
        vehicles {
          id
          licensePlate
          audioIssuanceStatus
          imei
          vehicleType {
            category
            companyId
            formattedVehicleType
            manufacturer
            model
            type
            vehicleTypeId
          }
            vehicle2Vgroup {
            vehicleId
            vgroup {
              companyId
              id
              isDefault
              name
            }
            vgroupId
          }        
        }
        geofences {
          geofenceId
          fenceName
        }
        allSupportedVehicles
        hasInaccessibleVehicles
        successfulAudioIssuance
        totalAudioIssuance
      }
      pagination {
        total
        page
        show
        startCursor
        endCursor
        actualTotal
      }
    }
    
  }
}
`

export const audioAssignment = gql`
query AudioAssignment($filter: AudioAssignmentFilter!) {
  audioAssignment(filter: $filter) {
    isSuccessful
    errorCode
    errorName
    message
    status
    audioAssignment {
      audioAssignmentId
      companyId
      audioFileId
      label
      assignmentType
      assignmentValue
      audioFile {
        audioFileId
        companyId
        label
        audioFileUrl
      }
      vehicles {
        id
        licensePlate
      }
      geofences {
        geofenceId
        fenceName
      }
      allSupportedVehicles
      hasInaccessibleVehicles
    }
  }
}
`

export const createAudioAssignment = gql`
  mutation CreateAudioAssignment($input: CreateAudioAssignmentInput!) {
  createAudioAssignment(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    createAudioAssignment {
      audioAssignmentId
      companyId
      audioFileId
      label
      assignmentType
      assignmentValue
    }
  }
}
`

export const updateAudioAssignment = gql`
  mutation UpdateAudioAssignment($input: UpdateAudioAssignmentInput!) {
  updateAudioAssignment(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    updateAudioAssignment {
      audioAssignmentId
      companyId
      audioFileId
      label
      assignmentType
      assignmentValue
    }
  }
}
`

export const deleteAudioAssignment = gql`
  mutation DeleteAudioAssignment($input: DeleteAudioAssignmentInput!) {
  deleteAudioAssignment(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    deleteAudioAssignment {
      audioAssignmentId
      companyId
      audioFileId
      label
      assignmentType
      assignmentValue
      audioFile {
        audioFileId
        companyId
        label
        audioFileUrl
      }
      vehicles {
        id
        licensePlate
      }
      geofences {
        geofenceId
        fenceName
      }
      allSupportedVehicles
      hasInaccessibleVehicles
    }
  }
}
`

export const conflictAudioAssignments = gql`
  query AudioAssignmentConflicts($filter: AudioAssignmentConflictsFilter!) {
  audioAssignmentConflicts(filter: $filter) {
    isSuccessful
    errorCode
    errorName
    message
    status
    audioAssignmentConflicts {
      data {
        audioAssignmentId
        label
        assignmentValue
        audioFile {
          audioFileId
          companyId
          label
          audioFileUrl
        }
        vehicle {
          id
          licensePlate
        }
        geofence {
          geofenceId
          fenceName
        }
      }
      pagination {
        total
        page
        show
        startCursor
        endCursor
        actualTotal
      }
    }
  }
}
`

export const vehicleSupport = gql`
  query VehiclesByFeatureSupport($filter: VehiclesByFeatureSupportFilter!) {
  vehiclesByFeatureSupport(filter: $filter) {
    isSuccessful
    errorCode
    errorName
    message
    status
    vehiclesByFeatureSupport {
      data {
        id
        status
        imei
        licensePlate
        vehicleTypeId
        vehicleType {
          manufacturer
          model
          type
          category
        }
        vehicle2Vgroup {
          vehicleId
          vgroupId
          vgroup {
            id
            companyId
            name
          }
        }
        featureSupported
        featureNetworkMode
      }
      allSupportedVehicleIds
      allUnsupportedVehicleIds
      pagination {
        total
        page
        show
        startCursor
        endCursor
        actualTotal
      }
    }
  }
}
`

export const retryAudioIssuance = gql`
  mutation RetryAudioIssuance($input: RetryAudioIssuanceInput!) {
  retryAudioIssuance(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    retryAudioAssignmentAudioIssuance {
      count
    }
    
  }
}
`